// 'pending', 'in_progress', 'completed', 'on_hold', 'cancelled', 'under_review','approved','rejected';
// 'pending' - Task is not started yet (default) - đã tạo, chưa bắt đầu
// 'in_progress' - Task is in progress - đang thực hiện
// 'completed' - Task is completed - đã xong
// 'on_hold' - Task is on hold - tạm dừng
//  'cancelled' - Task is cancelled - đã hủy
//  'under_review' - Task is under review - đang xem xét
//  'approved' - Task is approved - đã duyệt

import {calculateDaysDiff} from '@/lib/utils';

//  'rejected' - Task is rejected - bị từ chối
export const TaskStatuses = [
  {id: 'pending', label: 'Chưa bắt đầu'},
  {id: 'in_progress', label: 'Đang thực hiện'},
  {id: 'completed', label: 'Hoàn thành'},
  {id: 'cancelled', label: 'Đã hủy'},
  {id: 'on_hold', label: 'Tạm dừng'},
  {id: 'under_review', label: 'Đang nghiên cứu'},
  // {id: 'approved', label: 'Đã duyệt'},
  // {id: 'rejected', label: 'Từ chối'},
];

export const TaskPriorities = [
  {id: 1, label: 'Thấp'},
  {id: 2, label: 'Trung bình'},
  {id: 3, label: 'Cao'},
  {id: 4, label: 'Cấp bách'},
];

export const TaskMemberTypes = [
  {id: 'editor', label: 'Người được sửa'},
  {id: 'member', label: 'Người thực hiện'},
  // {id: 'incharge', label: 'Người phụ trách'},
  {id: 'viewer', label: 'Người được xem'},
];

// Get priority info from TaskPriorities
export const getPriorityInfo = priorityValue => {
  const priority = TaskPriorities.find(p => p.id === priorityValue) || TaskPriorities[0];

  // Define colors based on priority levels
  const colorMap = {
    1: 'text-green-500', // Thấp
    2: 'text-yellow-500', // Trung bình
    3: 'text-orange-500', // Cao
    4: 'text-red-600', // Cấp bách
  };

  return {
    text: priority.label,
    color: colorMap[priority.id] || 'text-gray-500',
  };
};

// Define colors based on status
const taskStatusColorMap = {
  pending: 'text-gray-500',
  in_progress: 'text-blue-500',
  completed: 'text-green-500',
  on_hold: 'text-yellow-500',
  cancelled: 'text-orange-500',
  under_review: 'text-purple-500',
  // others
  delayed: 'text-red-500',
  fallback: 'text-gray-500',
};

const taskStatusBgColorMap = {
  pending: 'bg-gray-100',
  in_progress: 'bg-blue-100',
  completed: 'bg-green-100',
  on_hold: 'bg-yellow-100',
  cancelled: 'text-orange-100',
  under_review: 'bg-purple-100',
  // others
  delayed: 'bg-red-100',
  fallback: 'bg-gray-100',
};

// Get status info from TaskStatuses
export const getStatusInfo = (statusValue, data: any = undefined) => {
  const status = TaskStatuses.find(s => s.id === statusValue) || {
    id: statusValue,
    label: statusValue,
  };

  const text = status.label;
  let color = taskStatusColorMap[status.id] || taskStatusColorMap.fallback;
  let bgcolor = taskStatusBgColorMap[status.id] || taskStatusBgColorMap.fallback;

  if (status.id === 'in_progress') {
    const initialVariance = calculateDaysDiff(
      data?.initial_end_date,
      data?.actual_end_date || new Date(),
    );
    const rescheduledVariance = calculateDaysDiff(
      data?.rescheduled_end_date,
      data?.actual_end_date || new Date(),
    );
    // chậm so với kế hoạch?
    if (
      (initialVariance != undefined && initialVariance > 0) ||
      (rescheduledVariance != undefined && rescheduledVariance > 0)
    ) {
      color = taskStatusColorMap.delayed;
      bgcolor = taskStatusBgColorMap.delayed;
    }
  }

  return {
    text,
    color,
    bgcolor,
  };
};

// Status color mapping for consistent UI representation
export const TaskStatusColors = {
  completed: '#10B981', // green
  in_progress: '#3B82F6', // blue
  pending: '#8B5CF6', // purple
  cancelled: '#EF4444', // red
  on_hold: '#F59E0B', // yellow
  under_review: '#6B7280', // gray
};

// Map status IDs to their positions in the color array for chart usage
export const getStatusColorMap = () => {
  const statusColorMap: {[key: string]: number} = {};
  const colors = Object.values(TaskStatusColors);

  TaskStatuses.forEach((status, index) => {
    statusColorMap[status.id] = index % colors.length;
  });

  return statusColorMap;
};
